import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.header,
    attrs: {
      "id": _setup.HEADER_ID,
      "app": "",
      "fixed": "",
      "role": "banner"
    }
  }, [_c('div', {
    class: [_vm.$style.headerInner, _defineProperty({}, _vm.$style.container, _setup.isLandingPage)]
  }, [_c('NuxtLink', {
    class: _vm.$style.logo,
    attrs: {
      "to": _setup.ROUTE_PATHS.index
    }
  }, [_c(_setup.TheLogo)], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    class: _vm.$style.left
  }, [_vm.isBackLinkActive ? _c('a', {
    class: _vm.$style.link,
    attrs: {
      "href": _setup.mainSiteLink
    }
  }, [_c(_setup.SButton, {
    class: _vm.$style.backBtn,
    attrs: {
      "equal": "",
      "theme": "ghost",
      "size": "small",
      "only-visual": ""
    }
  }, [_c(_setup.SIcon, {
    attrs: {
      "icon": "i-arrowLeft",
      "size": "24"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.linkText
  }, [_vm._v("\n            Вернуться на главный сайт\n          ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    class: _vm.$style.right
  }, [_c('client-only', [_c(_setup.HoverableLink, {
    class: _vm.$style.hoverableLink,
    attrs: {
      "href": "tel:".concat(_setup.phone),
      "text": _setup.preparedPhone,
      "font-size": "14px"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function fn() {
        return [_c(_setup.SButton, {
          class: _vm.$style.phoneButton,
          attrs: {
            "equal": "",
            "size": "custom",
            "theme": "ghost",
            "only-visual": ""
          }
        }, [_c(_setup.SIcon, {
          attrs: {
            "icon": "i-phone",
            "size": "24"
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _vm.isLoginButtonActive ? _c(_setup.SButton, {
    class: [_vm.$style.button, _vm.$style.hoverBase],
    attrs: {
      "n-link": "",
      "href": "/login",
      "rounded": "",
      "size": "x-small",
      "theme": "primary"
    }
  }, [_vm._v("\n          Войти / Зарегистрироваться\n        ")]) : _vm._e()], 1)])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };